/**
 * Created by kz on 28.06.17.
 */
import * as api from '@api/mailing'

export const all = ({commit}) => {
  commit('loading', true, {root: true})
  return api.getMailings()
    .then(({data}) => {
      commit('receive', data)
      commit('loading', false, {root: true})
    })
}

export const get = ({commit}, id) => {
  commit('loading', true, {root: true})
  return api.getMailing(id)
    .then(({data}) => {
      commit('current', data)
      commit('loading', false, {root: true})
    })
    .catch((error) => {
      commit('errorMessage', error.response.data.message, {root: true})
      commit('loading', false, {root: true})
      throw error
    })
}

export const create = ({commit, dispatch}, {tenderId, stageId, name}) => {
  commit('loading', true, {root: true})
  return api.create({tenderId, stageId, name})
    .then(() => {
      commit('loading', false, {root: true})
      dispatch('all')
    })
    .catch((error) => {
      commit('errorMessage', error.response.data.message, {root: true})
      commit('loading', false, {root: true})
      throw error
    })
}

export const update = ({state, commit, dispatch}, {text, date, recipients}) => {
  commit('loading', true, {root: true})
  return api.update(state.current._id, {text, date, recipients})
    .then(() => {
      commit('loading', false, {root: true})
      dispatch('get', state.current._id)
    })
    .catch((error) => {
      commit('errorMessage', error.response.data.message, {root: true})
      commit('loading', false, {root: true})
      throw error
    })
}

export const attachAttachment = ({dispatch, commit, state}, attachment) => {
  commit('loading', true, {root: true})
  return api.attachment(state.current._id, attachment)
    // .then(() => {
    //   // return dispatch('get', state.current._id)
    // })
    .then(() => {
      commit('successMessage', 'Условия загружены', {root: true})
      commit('loading', false, {root: true})
      return true
    })
}



// WEBPACK FOOTER //
// ./src/store/modules/mailing/actions.js